export const DEFAULT_PAGE_TITLE = 'Motilal Oswal PE :: AIF';

export const formatPageTitle = (pageTitle: string): string =>
  `${pageTitle} | ${DEFAULT_PAGE_TITLE}`;

const isIdSegment = (segment: string): boolean =>
  /^\d+$/.test(segment) || /^[a-f0-9-]{36}$/i.test(segment);

const segmentToTitle = (segment: string): string =>
  segment
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export const getPageTitleFromPath = (pathname: string): string => {
  const segments = pathname.replace(/\/+$/, '').split('/').filter(Boolean);

  if (segments.length === 0) {
    return DEFAULT_PAGE_TITLE;
  }

  let titleSegment = segments[segments.length - 1];
  if (isIdSegment(titleSegment) && segments.length > 1) {
    titleSegment = segments[segments.length - 2];
  }

  if (titleSegment === 'details' && segments.length > 1) {
    titleSegment = segments[0];
  }

  if (isIdSegment(titleSegment)) {
    return DEFAULT_PAGE_TITLE;
  }

  return formatPageTitle(segmentToTitle(titleSegment));
};
